import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg-player",
  "use": "svg-player-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" fill=\"#fff\" stroke=\"#000\" stroke-width=\"3\" id=\"svg-player\"><ellipse cx=\"16\" cy=\"10\" rx=\"4\" ry=\"8\" /><ellipse cx=\"16\" cy=\"16\" rx=\"6\" ry=\"6\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol